import * as React from "react";
import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { formatMenuItemPriceV2 } from "../../helpers/menuItemHelper";
import { DINE_IN_TABLE_SITTINGS_MENU_ITEMS_STATUS } from "../../constants/data";
import { MenuItem } from "../../models/menuItem";

interface Props {
  menuItem: MenuItem;
}

const MenuItemInfo: React.FC<Props> = ({ menuItem }) => {
  const isNotAvailable = menuItem.status === DINE_IN_TABLE_SITTINGS_MENU_ITEMS_STATUS.na;
  const hasImages = menuItem.media.length > 0;

  const headerClass = isNotAvailable ? "menu-item-header not-available" : "menu-item-header";
  return (
    <div>
      <div className="row" style={{marginTop: !hasImages ? 60 : 20}}>
          <div className="col-8">
              <Typography color="textSecondary" gutterBottom align="left" className={headerClass}>
                  {LocalizerHelper.localized(menuItem, ['name'])}
              </Typography>
          </div>
          <div className="col-4 text-right">
              <Typography color="textSecondary" gutterBottom align="right" className={headerClass}>
                  {formatMenuItemPriceV2(menuItem)}
              </Typography>
          </div>
      </div>
      <div className="row">
          <div className="col-12 text-left" style={{whiteSpace:"pre-line"}}>
              {LocalizerHelper.localized(menuItem, ['description'])}
          </div>
      </div>
    </div>
  );
};

export default MenuItemInfo;
